import { render, staticRenderFns } from "./AddressFormComponent.vue?vue&type=template&id=6f320a2e"
import script from "./AddressFormComponent.vue?vue&type=script&lang=js"
export * from "./AddressFormComponent.vue?vue&type=script&lang=js"
import style0 from "./AddressFormComponent.vue?vue&type=style&index=0&id=6f320a2e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports